import React from 'react';
import {useTranslation} from "../hooks/useTranslation";
import {FilterDemand} from "../types/filterDemand";

type DownloadsFilterProps = {
    searchTerm : string
    setSearchTerm : (input: string) => void
    demand : FilterDemand
    setDemand : (demand: FilterDemand) => void
}

function DownloadsFilterSearch({searchTerm, setSearchTerm, demand, setDemand} : DownloadsFilterProps) {

    const translate = useTranslation();

    return (
        <div className='downloadsOverview__filter--search'>
            <input className='form-control' value={searchTerm}
                   onChange={(event) => {
                       setSearchTerm(event.target.value);
                       // TODO: Q: how to set value async? if we use state the term who will be passed is not complete
                       setDemand({...demand, term: event.target.value}
                       )
                   }}
                   placeholder={translate('downloads.search.placeholder')}
                   aria-label={translate('downloads.search.label')}
            />

            { searchTerm.length > 0 &&
                <button className={'downloadsOverview__filter--search-reset'}
                   onClick={() => {
                       setSearchTerm('');
                       setDemand({...demand, limit: 15, term: ''})
                   }}
                   aria-label={translate('downloads.search.reset.label')}
                />
            }
            <span className='downloadsOverview__filter--search-icon'/>
        </div>
    );
}

export default DownloadsFilterSearch;
